<template>
  <div class="container">
    <vs-breadcrumb :items="[
        { title: 'Modelos de riesgo', url: '/risk-model/admin' }]"></vs-breadcrumb>

    <vs-card>
      <div slot="header" class="mb-4">
        <h4 class="float-left">Editor de versión</h4>
        <vs-button
            @click="saveVersionHandle"
            color="primary"
            size="small"
            class="float-right">
          Guardar
        </vs-button>
      </div>
      <div class="risk-model-editor container">
        <div class="flex p-5 bg-white font-bold uppercase">
          <div class="w-9/12">CATEGORÍA</div>
          <div class="w-3/12">PESO DE LA CATEGORÍA</div>
        </div>
        <div>
          <draggable :list="version.groups" class="cursor-move">
            <risk-model-group-item
                @onAddItem="saveVersionHandle"
                :catalogs="catalogs"
                v-for="(group, idx) in version.groups"
                :group="group"
                :key="idx"></risk-model-group-item>
          </draggable>
        </div>
      </div>
    </vs-card>
  </div>
</template>
<script>
import RiskModelGroupItem from "./RiskModelGroupItem.vue";
import draggable from 'vuedraggable'

export default {
  name: "RiskModelEditor",
  components: {RiskModelGroupItem, draggable},
  data: () => ({
    versionId: 0,
    version: {},
    catalogs: [],
    showVersionEditorDialog: false,
    newIndicator: {
      name: '',
      identity_name: '',
      weight: 0,
      analysis_type: {
        id: 0,
        name: ''
      },
      worst_value: 0,
      best_value: 0
    }
  }),
  async mounted() {
    this.$vs.loading();
    try {
      const {data} = await axios.get("/api/risk-model/version/" + this.$route.params.id)
      this.version = data;

      let catalogResponse = await axios.get("/api/risk-model/catalog");
      this.catalogs = catalogResponse.data;

      this.$vs.loading.close();
    } catch (e) {
      this.$vs.loading.close();
    }
  },
  methods: {
    async saveVersionHandle() {
      this.$vs.loading();
      try {
        await axios.put("/api/risk-model/version/" + this.$route.params.id, this.version)
        this.$vs.loading.close();
        alert("La version se guardo correctamente")
      } catch (e) {
        this.$vs.loading.close();
      }
    }
  }
}
</script>
<style scoped>

</style>